import { ChangeDetectorRef, Component, ElementRef, NgZone, OnInit, ViewContainerRef } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Constants } from '@constants';
import { EstimateBaseComponent } from '@fs/components/base/estimate-base.component';
import { FsUtil } from '@fs/services/fs-utils';
import { ItemSelectorMetaModel, ItemSelectorType } from '@fs/models/item-selector.model';
import { EstimateAppointmentModel, EstimateNoteModel, EstimateOptionModel, EstimatePriceBookModel, EstimateRequestModel } from '@fs/models/estimate/estimate-request.model';
import { DiscountSelectorModel } from '@fs/models/discount-selector.model';
import { CommonMethods } from '@services/common.method';
import { SpinnerService } from '@shared/services/spinner.service';
import { WorkTicketPaymentSummary } from '@fs/models/work-order/work-order.model';
import { CommonService } from '@shared/services/common.service';
import { AuthService } from '@services/auth.service';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { CodeTypeModel } from '@fs/models/code-type.model';
import { PriceBucketModel } from '@fs/models/price-book/price-book.model';
import { forkJoin } from 'rxjs';
import { DatePipe } from '@angular/common';
import { UploadAttachmentMetaModel } from '@fs/models/upload-attachment.modal';
import { EstimateService } from '@fs/services/estimate/estimate.service';
import { NotificationsService } from '@shared/services/notification-service';
import { TabOpenService } from '@services/tab-open.service';
import { customJS } from '@fs/services/customjs';
import { TaxSelectorModel } from '@fs/models/tax-selector.model';
import { TabParams } from '@fs/services/tab-params.service';
import { EstimateResponseModel } from '@fs/models/estimate/estimate-response.model';
import { ISubscription } from "rxjs/Subscription";

interface EstimateMetData {
  ServiceTypes: CodeTypeModel[],
  Departments: CodeTypeModel[],
  WorkTicketPriorityLookup: CodeTypeModel[]
}
@Component({
  selector: 'estimate-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss'],
  providers: [DatePipe, EstimateService]
})
export class EstimateCreateComponent extends EstimateBaseComponent implements OnInit {
  tabCounter: number;
  estimateForm: FormGroup;
  itemMetaData: ItemSelectorMetaModel;
  agreementDiscount = 0;
  customDiscountForm: FormGroup;
  popupDiscountType: string = "";
  discountSelector: DiscountSelectorModel;
  paymentDetails: WorkTicketPaymentSummary = new WorkTicketPaymentSummary();
  showSlider = false;
  priceBucket: PriceBucketModel;
  estimateMetaData: EstimateMetData;
  usersList = [];
  attachmentMetaData: UploadAttachmentMetaModel;
  editAttachmentItem: any;
  showAttachmentSlider: boolean = false;
  slideIndex: number = 0;
  today = new Date();
  minimumDate: Date = new Date(this.today.getFullYear()+'-'+(this.today.getMonth()+1)+'-'+this.today.getDate()) ;
  loadTaxEditor = false;
  taxMetaData: TaxSelectorModel;
  isUnsavedTriggered: boolean = false;
  data: EstimateResponseModel;
  isAddMode: Boolean = true;  
  desc: string = "desc";
  public overrideItemIds = [];
  private set inputParams(val)  {
    this.data = val;
    if (!FsUtil.checkNullOrUndefined([this.data.ID], true))
      this.isAddMode = false;
  }; 
  
  constructor(private frmbuilder: FormBuilder, private changeDetector: ChangeDetectorRef, private elementRef: ElementRef,
    private commonMethods: CommonMethods, private viewRef: ViewContainerRef, private spinnerService: SpinnerService,
    private commonService: CommonService, private authService: AuthService, private datePipe: DatePipe, private estimateService: EstimateService,
    private notificationService: NotificationsService, private tabOpenService: TabOpenService, private zone: NgZone) { 
    super();
    this.buildEstimateForm();
    this.setInitModels();
  }

  ngOnInit() {
    this.setInitData();
    this.registerOnInitchanges();
    this.initSubTabs();
    this.desc = this.desc + Math.random();
  }
  ngOnDestroy() {
      this.destroySubscriptions();
  }
  private destroySubscriptions() {
      this.ngUnsubscribe$.next();
      this.ngUnsubscribe$.complete();    
  }
  onTabSelect(index) {
    if (index === 1) { 
      this.showSlider = true;
    } else {
      this.showSlider = false;
    }
  }
  changeTab(index) {
    this.subTabs.forEach(x => {
      if(x.Index === index) {
        x.Selected = true;
      } else {
        x.Selected = false;
      }
    });
  }
  expandDiscountBox() {
    this.showSlider = !this.showSlider;
  }
  setInitData() {
    const ref = "ServiceTypes,Departments,workticketprioritylookup,pricebuckets";
    const http1 = this.commonService.GetIntialData(this.authService.getCompanyId(), ref);
    const http2 = this.commonService.GetTechnicianData(this.authService.getCompanyId(), 'Department');
    this.spinnerService.showloader(this.viewRef, this.tabCounter, 0);
    const httpList = [http1, http2];
    if (!this.isAddMode) {
        httpList.push(this.estimateService.GetEstimate(this.data.Customer.ID, this.data.JobSite.ID, this.data.ID));

        this.tabOpenService.routeToParentEvent
            .pipe(takeUntil(this.ngUnsubscribe$)).subscribe((response: any) => {
                if (
                    response.tabCounter == this.tabCounter &&
                    response.event.split("|")[0] == "replaceTab" &&
                    response.event.split("|")[1] == "discard"
                ) {
                    this.tabOpenService.ReplaceTab({
                        CurrentTabIndex: this.tabCounter,
                        newTabInfo: TabParams.ViewEstimate(this.data)
                    }, false);
                } else if (
                    response.tabCounter == this.tabCounter &&
                    response.event.split("|")[0] == "replaceTab" &&
                    response.event.split("|")[1] == "save"
                ) {
                    this.createEstimate(true);
                }
            });
        
    } else {
      httpList.push(this.commonService.getTaxGroup(this.data.JobSite.TaxGroup.ID));
    }

    forkJoin(httpList)
      .pipe(takeUntil(this.ngUnsubscribe$))
        .subscribe((x) => {
          this.estimateMetaData = x[0];
          this.priceBucket = x[0].PriceBuckets.find(x => x.Name.toLowerCase() == "standard");
          this.usersList = x[1];
          if (!this.isAddMode) {
            this.data = x[2];
            this.setEditFormData();
          } else {
            this.taxMetaData.selectedTaxGroup = this.data.JobSite.TaxGroup;
            this.taxMetaData.selectedTaxGroup.TaxCodes = x[2].TaxCodes;
          }
          this.spinnerService.hideLoader(this.viewRef, this.tabCounter);
        });
  }
  setInitModels() {
    this.itemMetaData = { 
      showConfirm: false, 
      selectedItems: [], 
      selectedMaterialItems: [] 
    };
    this.discountSelector = { 
      showCustomModal: false, 
      customDiscount: null, 
      selectedDiscount: {
        Discount: null,
        DiscountType: null,
        IsCustom: false,
        EstimatePriceBookItemIDs: [],
        IsDeleted: true,
        IsDirty: false,
        Name: '',
        Rate: 0
      },
      disabled: false
    };
    this.attachmentMetaData = {
      attachments: [],
      externalUrl: 'estimate/externalestimateattachment',
      showAttachment: false,
      uploadUrl: 'estimate/estimateattachment',
      deleteItem: null
    };
    this.taxMetaData = {
      showModal: false,
      paymentDetails: null,
      selectedTaxGroup: null,
      totalTaxRate: 0
    };
  }
  registerOnInitchanges() {    
    this.tabOpenService.ConfirmDestroyTabEvent
    .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(r => { if (r.tabCounter == this.tabCounter) { this.createEstimate(); } 
    });    
    this.estimateForm.get('estimateInfo').valueChanges
      .pipe(takeUntil(this.ngUnsubscribe$))
        .subscribe(() => {
          this.formDirtyDetection();
        });    
    this.estimateForm.get('Appointments').valueChanges
      .pipe(takeUntil(this.ngUnsubscribe$))
        .subscribe(() => {
          this.formDirtyDetection();
        });     
    this.tabOpenService.ChangeComponentEvent.pipe(takeUntil(this.ngUnsubscribe$)).subscribe(response => {        
        this.destroySubscriptions();        
    });    
  }
  formDirtyDetection() {
    if (!this.isUnsavedTriggered) {
      if (this.estimateForm.dirty) {
        this.isUnsavedTriggered = true;
        this.tabOpenService.unsavedChangedDetected({
          dirty: true,
          Index: this.tabCounter
        });
      }
    }
  }
  buildEstimateForm() {
    this.estimateForm = this.frmbuilder.group({
      estimateInfo: this.buildEstimateInfoForm(),
      Appointments: new FormArray([])
    });
  }
  buildEstimateInfoForm() {
    return this.frmbuilder.group({
      ID: new FormControl(''),
      Description: new FormControl(''),
      CreateDate: new FormControl( {value: new Date(), disabled: true}),
      ExpirationDate: new FormControl(new Date().addDays(29), Validators.required),
      OwnerUserID: new FormControl(this.authService.getUserId()),
      ServiceTypeID: new FormControl(''),
      DepartmentID: new FormControl(''),
      DurationHour: new FormControl(),
      DurationMin: new FormControl(),
      PriorityID: new FormControl(''),
      OriginWorkTicketID: new FormControl(''),
      ExternalNote: new FormControl(),
      InternalNote: new FormControl()
    });
  }
  createEstimate(replace: boolean = true) {
    if(!this.estimateForm.valid || $(this.elementRef.nativeElement).find(".ng-invalid").length > 0) {
      this.commonMethods.markFormGroupTouched(this.estimateForm);
      this.commonMethods.markFormArrayTouched(this.estimateForm.get('Appointments') as FormArray);
      this.zone.runOutsideAngular(() => {
        customJS.verifyBoxes(this.elementRef.nativeElement);
      });      
      return;
    }

    if (this.paymentDetails.TotalAmount < 0 && Math.abs(this.paymentDetails.DiscountAmount) > 0) {
      this.notificationService.error("Please remove discount and save as Subtotal is negative.", "Error");
      return;
    }

    if (this.paymentDetails.TotalApproved < 0) {
      this.notificationService.error("Estimate cannot be negative.", "Error");
      return;
    }

    this.spinnerService.showloader(this.viewRef, this.tabCounter, 0);
    let http;
    let model = this.getRequestModel();
    if (this.isAddMode) {
      http = this.estimateService.PostEstimate(this.data.Customer.ID, this.data.JobSite.ID, model);
    } else {
      model.ID = this.data.ID;
      http = this.estimateService.PutEstimate(this.data.Customer.ID, this.data.JobSite.ID, this.data.ID, model);
    }
    http
      .pipe(debounceTime(1000), takeUntil(this.ngUnsubscribe$))
        .subscribe((x) => {
          this.spinnerService.hideLoader(this.viewRef, this.tabCounter);
          this.zone.runOutsideAngular(() => {
            customJS.markTabAsPristine(this.elementRef.nativeElement);
          });
          const message = `Estimate  ${x.EstimateNo} ${this.isAddMode? 'created': 'updated'} successfully`;
          this.notificationService.success(message, "Success");
          if (replace || !this.isAddMode) {
            x['Customer'] = this.data.Customer;
            x['JobSite'] = this.data.JobSite;
            this.tabOpenService.ReplaceTab({ CurrentTabIndex: this.tabCounter,
                                          newTabInfo: TabParams.ViewEstimate(x)
                                        }, false);
          } else {
            this.tabOpenService.DestroyTab(this.tabCounter);
          }
          this.zone.runOutsideAngular(() => {
            customJS.scrollToPageHeader();
          });
        }, (e) => {
          this.spinnerService.hideLoader(this.viewRef, this.tabCounter);
          if (!CommonMethods.CheckNullOrUndefined(e.error.Message))
            this.notificationService.showMultiLineError(e.error.Message, "Error");
        });
  }
  itemChange(type: ItemSelectorType) {
    this.estimateForm.markAsDirty();
    if (type !== 'description' &&  type !== 'note') {
      this.setAgreementDiscount();
      this.applyDiscountAndTax();
    }
    this.formDirtyDetection();
  }
  removeItem(dataItem) {
    const currentIndex = this.itemMetaData.selectedItems.indexOf(dataItem);
    const workTicketPriceBookLinkingId = this.itemMetaData.selectedItems[currentIndex].WorkTicketPriceBookLinkingId;
    if (!FsUtil.checkNullOrUndefined([workTicketPriceBookLinkingId], true)) {
      this.itemMetaData.selectedMaterialItems.filter(x => x.WorkTicketPriceBookItem != null && x.WorkTicketPriceBookItem.ID == workTicketPriceBookLinkingId)
        .forEach(y => {
          let idx = this.itemMetaData.selectedMaterialItems.indexOf(y);
          this.itemMetaData.selectedMaterialItems.splice(idx, 1);
        });
    }
    this.itemMetaData.selectedItems.splice(currentIndex, 1);
      this.itemMetaData.selectedItems.map((x, i) => { if (x.LineCounter != i + 1) { x.LineCounter = i + 1; x.Dirty = true; } } );
    this.setAgreementDiscount();
    this.applyDiscountAndTax();
  }
  applyDiscount(val) {
    if (this.discountSelector.disabled) return;
    if (this.discountSelector.showCustomModal) {
      this.customDiscountForm = this.frmbuilder.group({
        Name: new FormControl({ value: this.discountSelector.customDiscount.Name, disabled: !this.discountSelector.customDiscount.IsNameEditable }, Validators.required),
        Rate: new FormControl({ value: this.discountSelector.customDiscount.Amount, disabled: !this.discountSelector.customDiscount.IsAmountEditable })
      });
    } else {
      const isDirty = val.DiscountType.Code != "percent" ? null : true;
      this.setDiscountValues(val, isDirty);
    }
    this.applyDiscountAndTax();
    this.changeDetector.detectChanges();
  }
  applyCustomDiscount() {
    if (
      (this.discountSelector.customDiscount.IsNameEditable && this.customDiscountForm.valid) ||
      !this.discountSelector.customDiscount.IsNameEditable
    ) {
      let discount = Object.assign({}, this.discountSelector.customDiscount);
      discount["Name"] = this.customDiscountForm.controls["Name"].value;
      discount["Rate"] = this.customDiscountForm.controls["Rate"].value;
      discount["Amount"] = this.customDiscountForm.controls["Rate"].value;
      discount["IsCustom"] = true;
      if ((discount.DiscountType.Code == "percent" &&  discount["Rate"] <= 99) || 
          (discount.DiscountType.Code == "dollar" &&  discount["Rate"] <= 999.99)) {
        this.setDiscountValues(discount, true);
        this.closeCustomDiscount();
        this.applyDiscountAndTax();
        this.changeDetector.detectChanges();
      }
    } else {
      this.commonMethods.markFormGroupTouched(this.customDiscountForm);
    }
  }
  closeCustomDiscount() {
    this.customDiscountForm.reset();
    this.discountSelector.showCustomModal = false;
    this.discountSelector.customDiscount = null;
  }
  removeDiscount() {
    this.discountSelector.customDiscount = null;
    this.discountSelector.selectedDiscount.IsDeleted = true;
    this.applyDiscountAndTax();
  }
  openAttachment(e) {
    e.stopPropagation();
    this.attachmentMetaData.showAttachment = true;
  }
  viewAttachmentSlide(idx: number) {
    this.slideIndex = idx;
    this.showAttachmentSlider = true;
  }
  closeAttachmentSlider() {
    this.showAttachmentSlider = false;
  }
  setDefaultImage(event, dataItem) {
    let oldDefaultImage = this.attachmentMetaData.attachments.find(x => x.IsDefaultImage);
    this.attachmentMetaData.attachments.forEach(x => {
      if (x == dataItem) {
        x.IsDirty = !CommonMethods.CheckNullOrUndefined(x.ID);
        x.IsDefaultImage = $(event.target)[0].checked;
      } else {
        if (x == oldDefaultImage) {
          x.IsDirty = !CommonMethods.CheckNullOrUndefined(oldDefaultImage.ID);
          x.IsDefaultImage = false;
        }
      }
    });
  }
  onEditAttachment(dataItem) {
    this.editAttachmentItem = dataItem;
  }
  onDeleteAttachment(dataItem) {
    this.attachmentMetaData.deleteItem = dataItem;
  }
  openTaxEditor() {
    this.loadTaxEditor = true;
    this.taxMetaData.showModal = true;
  }
  applyTax() {
    this.estimateForm.markAsDirty();
    this.applyDiscountAndTax();
    this.formDirtyDetection();
  }
  attachmentChange() {
    this.estimateForm.markAsDirty();
    this.formDirtyDetection();
  }
  cancelEstimate() {
    if (this.isAddMode) {
      this.tabOpenService.DestroyTab(this.tabCounter);
    } else {
      this.tabOpenService.ReplaceTab({ 
        CurrentTabIndex: this.tabCounter,
        newTabInfo: TabParams.ViewEstimate(this.data)
      }, true);
    }
  }
  setEditFormData() {
    const estimateInfo = this.estimateForm.get('estimateInfo');
    estimateInfo.get('ID').setValue(this.data.ID);
    estimateInfo.get('Description').setValue(this.data.Description);
    estimateInfo.get('ExpirationDate').setValue(new Date(this.data.ExpirationDate));
    if (this.data.Duration) {
      const duration = this.data.Duration.split(":");
      if (duration.length > 0) {
        estimateInfo.get('DurationHour').setValue(duration[0]);
        estimateInfo.get('DurationMin').setValue(duration[1]);
      }
    }
    if (this.data.OwnerUser)
      estimateInfo.get('OwnerUserID').setValue(this.data.OwnerUser.ID);
    if (this.data.ServiceType)
      estimateInfo.get('ServiceTypeID').setValue(this.data.ServiceType.ID);
    if (this.data.Department)
      estimateInfo.get('DepartmentID').setValue(this.data.Department.ID);
    if (this.data.Priority)
      estimateInfo.get('PriorityID').setValue(this.data.Priority.ID);
    if(this.data.OriginWorkTicket)
      estimateInfo.get('OriginWorkTicketID').setValue(this.data.OriginWorkTicket.ID);

    // Notes
    const externalNote = this.data.Notes.find(x => x.Type.ID === this.commonMethods.getCodeTypeData('NoteType').find(x => x.Code.toLowerCase() == "estimateexternal").ID);
    const internalNote = this.data.Notes.find(x => x.Type.ID === this.commonMethods.getCodeTypeData('NoteType').find(x => x.Code.toLowerCase() == "estimateinternal").ID);
    if (externalNote)
      estimateInfo.get('ExternalNote').setValue(externalNote.Content);
    if (internalNote)
      estimateInfo.get('InternalNote').setValue(internalNote.Content);

    // Appointments
    const userAppointment =  this.data['UserAppointment'];
    this.data.UserAppointments = [];
    if (userAppointment) {
      this.data.UserAppointments.push(userAppointment);
    }
    this.data.UserAppointments.forEach(x => {
      let appointmentDate: string = this.datePipe.transform(x.AppointmentDate, "MM/dd/yyyy");
      let startTimeDt: Date = new Date(appointmentDate + " " + x.StartTime);
      let endTimeDt: Date = new Date(appointmentDate + " " + x.EndTime);
      let durationHour: number = 0;
      let durationMin: string = '00';
      let duration: number = 0;

      if (!isNaN(startTimeDt.getTime()) && !isNaN(endTimeDt.getTime())) {
        let hours = Math.floor((endTimeDt.getTime() - startTimeDt.getTime()) / 3600000);
        let min = (Math.floor((endTimeDt.getTime() - startTimeDt.getTime()) % 3600000) / 60000);
        durationHour = hours;
        durationMin = (min == 0 ? '00' : min.toString());
        duration = (durationHour) * 60 + parseInt(durationMin);
      }
      const status = this.commonMethods.GetHelperStatus(x.StatusID, x.SubStatusID);
      const isCompleted = (status && status.Name === 'Completed')? true : false;
      (this.estimateForm.get('Appointments') as FormArray).push(new FormGroup({
        ID: new FormControl(x.ID),
        HelperId: new FormControl({ value: x.UserID, disabled: isCompleted }, Validators.required),
        Name: new FormControl(""),
        Date: new FormControl({ value: startTimeDt, disabled: isCompleted }, Validators.required),
        StartTime: new FormControl({ value: startTimeDt, disabled: isCompleted }, [Validators.required, this.commonMethods.oneDayValidator]),
        DurationHour: new FormControl({ value: durationHour, disabled: isCompleted }, [Validators.required, this.commonMethods.durationValidator]),
        DurationMin: new FormControl({ value: durationMin, disabled: isCompleted }, [Validators.required, this.commonMethods.durationValidator]),
        autoschedule: new FormControl({ value: x.IsSchedule, disabled: isCompleted }),
        Duration: new FormControl(duration),
        Note: new FormControl(x.Note),
        Dirty: new FormControl(false),
        ModifyDate: new FormControl(x.ModifyDate),
        StatusID: new FormControl(x.StatusID),
        SubStatusID: new FormControl(x.SubStatusID),
        IsEditNotAllowed: new FormControl(false),
        IsDeleteNotAllowed: new FormControl(false),
        ViewStartTime: new FormControl(""),
        Status: new FormControl((status)? status.Name: "")
      }));
    });  
    // Estimate options
    this.data.EstimateOptions.forEach(x => {
      // Attachments
      this.attachmentMetaData.attachments = x.EstimateAttachments.map(x => {
        const uploadedBy = x['CreatedByUser'];
        x['UploadedBy'] = !CommonMethods.CheckNullOrUndefined(uploadedBy)? `${uploadedBy.FirstName} ${uploadedBy.LastName}` : "";
        x['checkIsNotImage'] = this.commonMethods.CheckLinkIsNotImage(x); 
        x['IsImage'] = !x['checkIsNotImage']; 
        return x;
      });      
      // Items
      this.itemMetaData.selectedItems = x.EstimatePriceBookItems;
      this.itemMetaData.selectedItems.forEach(item => {
        item.ImagePath = this.commonMethods.GetProductDefaultImg(item.PriceBookItem);
        item.ItemNumber = item.PriceBookItem.ItemNumber;
        if (item.ServiceAgreement != null) {
          item.ServiceAgreementID = item.ServiceAgreement.ID;
          item.ServiceAgreementNo = item.ServiceAgreement.AgreementID;
        };
        item.Price = (item.AgreementPrice != null && item.Price == item.OriginalPrice)? item.AgreementPrice : item.Price;
        item.AccountingCode = item.PriceBookAccountingCode;
        if (item.IsUsedToOverridePrice == true) {
          this.overrideItemIds.push(item.PriceBookItem.ID);
        }
        if (item.PriceBookItem) {
          item.IsPriceEditAllowed = item.PriceBookItem.IsPriceEditAllowed;
          item.IsDescriptionEditAllowed = item.PriceBookItem.IsDescriptionEditAllowed;
          item.IsDiscountExcluded = item.PriceBookItem.IsDiscountExcluded;
          item.IsTaxable = item.PriceBookItem.IsTaxable;
          item.Type = item.PriceBookItem.Type;
        }
      });
      // Totals     
      if (x.EstimateOptionDiscountItems.length > 0)
        this.discountSelector.selectedDiscount = x.EstimateOptionDiscountItems[0];
    });
    this.taxMetaData.selectedTaxGroup = this.data.TaxGroup;
    this.setAgreementDiscount();
    this.applyDiscountAndTax();
  }
  private setDiscountValues(val: any, setDirty?: boolean) {
    const discount = Object.assign({}, val);
    let discountType = discount.DiscountType.Code;
    this.discountSelector.selectedDiscount.Name = discount.Name;
    this.discountSelector.selectedDiscount.Rate = discount.Rate;
    this.discountSelector.selectedDiscount.IsDeleted = false;
    this.discountSelector.selectedDiscount.DiscountType = discount.DiscountType;
    delete discount.DiscountType;
    this.discountSelector.selectedDiscount.Discount = discount;
    
    if (setDirty && setDirty == true)
      this.discountSelector.selectedDiscount.IsDirty = setDirty;

    if (!FsUtil.checkNullOrUndefined([discount["IsCustom"]])) {
      this.discountSelector.selectedDiscount.IsCustom = discount["IsCustom"];
    }
    if (discountType == "percent") {
      let discountableAmount = 0;
      this.itemMetaData.selectedItems.forEach(element => {
        if (!element.IsDiscountExcluded) {
          discountableAmount += element.Price * element.Quantity;
        }
      });
      // this.workTicketPayment.DiscountAmount = (discountableAmount * this.selectedDiscount.Rate) / 100; //Rate here will be rate %
    } else {
      // this.workTicketPayment.DiscountAmount = this.selectedDiscount.Discount.Amount; //Rate here will be actual amount in the dollars
    }
  }
  private setAgreementDiscount() {
    let totalAgreementPrice = 0;
    let totalStandardPrice = 0;
    this.itemMetaData.selectedItems.forEach((x: any) => {
      if (x.AgreementPrice != null && x.AgreementPrice == x.Price) {
        totalAgreementPrice += (x.Quantity * x.AgreementPrice);     
        totalStandardPrice += (x.Quantity * x.OriginalPrice);
      }
    });
    this.agreementDiscount = totalStandardPrice - totalAgreementPrice;
  }
  private applyDiscountAndTax() {
    this.setTotalTaxRate();
    let totalPrice = 0;
    let netTaxable = 0;
    let totalDiscount = 0;
    let totalTaxedAmount = 0;
    let positiveApprovedItems = this.itemMetaData.selectedItems.filter(x => x.Price * x.Quantity > 0);
    let positiveApprovedItemsTotAmt = positiveApprovedItems.reduce((a, b) => a + b.Quantity * b.Price, 0);
    let allApprovedItemsTotAmt = this.itemMetaData.selectedItems.reduce((a, b) => a + b.Quantity * b.Price, 0);

    // Calculate each item's discount and tax
    this.itemMetaData.selectedItems.forEach(element => {
      let totalItemPrice = element.Price * element.Quantity;
      let discount = 0;
      totalPrice = totalPrice + totalItemPrice;

      // Percent type discount
      if (!this.discountSelector.selectedDiscount.IsDeleted && this.discountSelector.selectedDiscount.DiscountType.Code == "percent") {
        discount = totalItemPrice > 0
          ? Math.round((totalItemPrice / positiveApprovedItemsTotAmt)
            * (this.discountSelector.selectedDiscount.Discount.Amount / 100)
            * allApprovedItemsTotAmt * 100) / 100
          : 0;
      }
      // Dollar type discount
      else if (!this.discountSelector.selectedDiscount.IsDeleted && this.discountSelector.selectedDiscount.DiscountType.Code == "dollar") {
        discount = totalItemPrice > 0
          ? (totalItemPrice / positiveApprovedItemsTotAmt) * this.discountSelector.selectedDiscount.Discount.Amount
          : 0;
      }

      // Calculate tax on the items after discount is applied
      if (element.IsTaxable) {
        let itemNetTaxable = totalItemPrice - discount;
        netTaxable += itemNetTaxable;
        totalTaxedAmount += ((itemNetTaxable * this.taxMetaData.totalTaxRate) / 100);
      }
    });
    if (!this.discountSelector.selectedDiscount.IsDeleted) {
      totalDiscount =
        this.discountSelector.selectedDiscount.DiscountType.Code == "dollar"
          ? this.discountSelector.selectedDiscount.Discount.Amount
          : totalPrice * (this.discountSelector.selectedDiscount.Discount.Amount / 100);
    }

    this.paymentDetails.TotalApproved = totalPrice.roundTo(2);
    this.paymentDetails.NetTaxable = netTaxable;
    this.paymentDetails.TaxedAmount = totalTaxedAmount;
    this.paymentDetails.DiscountAmount = totalDiscount;
    this.paymentDetails.TotalAmount = this.paymentDetails.TotalApproved + this.paymentDetails.TaxedAmount - this.paymentDetails.DiscountAmount;
    this.paymentDetails.TotalAmount = this.paymentDetails.TotalAmount.roundTo(2);
    this.taxMetaData.paymentDetails = Object.assign({}, this.paymentDetails);
    this.discountSelector.disabled = this.paymentDetails.TotalApproved < 0;
  }
  private setTotalTaxRate() {
    let rate = 0;
    if (this.taxMetaData.selectedTaxGroup) {
      this.taxMetaData.selectedTaxGroup.TaxCodes.forEach(element => {
        rate = rate + element.Rate;
      });
    }
    this.taxMetaData.totalTaxRate = rate;
  }
  private getRequestModel() {
    const estimateInfo = this.estimateForm.get('estimateInfo').value;
    var originWorkTicketID = "";
    if(this.data.OriginWorkTicket)
       originWorkTicketID =   this.data.OriginWorkTicket.ID;
    if(estimateInfo.DurationHour ==null && estimateInfo.DurationMin) 
        estimateInfo.DurationHour="00";
    else if (estimateInfo.DurationMin ==null && estimateInfo.DurationHour) 
        estimateInfo.DurationMin="00";
    const model: EstimateRequestModel = {
      DepartmentID: estimateInfo.DepartmentID,
      Description: estimateInfo.Description,
      Duration: '',
      ExpirationDate: this.datePipe.transform(estimateInfo.ExpirationDate, "MM/dd/yyyy"),
      OwnerUserID: estimateInfo.OwnerUserID,
      PriorityID: estimateInfo.PriorityID,
      ServiceTypeID: estimateInfo.ServiceTypeID,
      OriginWorkTicketID:  originWorkTicketID,
      EstimateOptions: [],
      Notes: [],
      UserAppointments: null,
      TaxGroup: null,
      ModifyDate: this.data.ModifyDate
    };
    
    if (estimateInfo.DurationHour || estimateInfo.DurationMin) {
      model.Duration = `${estimateInfo.DurationHour}:${estimateInfo.DurationMin}`;
    }
    
    if (this.taxMetaData.selectedTaxGroup) {
      model.TaxGroup = { ID: this.taxMetaData.selectedTaxGroup.ID };
    }
    //#region Appointments
    //const appointments = this.estimateForm.get("Appointments").value;
    let appointmentsList =this.estimateForm.getRawValue();
    if(appointmentsList.Appointments != null){
      appointmentsList.Appointments.forEach(x => {
      const startTime = `${x.Date.toDateString("MM/dd/yyyy")} ${x.StartTime.getHours()}:${x.StartTime.getMinutes()}:${x.StartTime.getSeconds()}`;
      const duration = parseInt(x.DurationHour) * 60 + parseInt(x.DurationMin);
      let objEndTime = new Date(x.StartTime);
      objEndTime.setMinutes(x.StartTime.getMinutes() + duration);
      const endTime = `${x.Date.toDateString("MM/dd/yyyy")} ${objEndTime.getHours()}:${objEndTime.getMinutes()}:${objEndTime.getSeconds()}`;
      
      const aptModel: EstimateAppointmentModel = {
        AppointmentDate: this.datePipe.transform(x.Date, "MM/dd/yyyy"),
        AppointmentTypeID: this.commonMethods.getCodeTypeData('AppointmentType').find(x => x.Code.toLowerCase() == "estimate").ID,
        StartTime: new Date(startTime).toTimeString().split(" ")[0],
        EndTime: new Date(endTime).toTimeString().split(" ")[0],
        IsSchedule: x.autoschedule,
        Note: x.Note,
        UserID: x.HelperId,
        IsDirty: x.Dirty
      };
      if (x.ID) {
        aptModel.ID = x.ID;
        aptModel.ModifyDate = x.ModifyDate;
      }
      model['UserAppointment'] = aptModel;
    });
    }
    delete model.UserAppointments;
    //#endregion

    //#region Options
    const optionModel: EstimateOptionModel = {
      LineCounter: 1,
      EstimateAttachments: [],
      EstimatePriceBookItems: [],
      EstimateItems: [],
      EstimateOptionDiscountItems: []
    };
    this.itemMetaData.selectedItems.forEach((x, i) => {
      const itemModel: EstimatePriceBookModel = {
        AgreementPrice: x.AgreementPrice,
        Description: x.Description,
        IsTaxable: x.IsTaxable,
        ItemStatusID: x.Status.ID,
        LineCounter: i+1,
        Note: x.Note,
        OriginalPrice: x.OriginalPrice,
        Price: (x.AgreementPrice != null && x.AgreementPrice == x.Price)? x.OriginalPrice : x.Price,
        PriceBucketID: this.priceBucket.ID,
        Quantity: x.Quantity,
        ServiceAgreementID: x.ServiceAgreementID,
        IsDirty: x.Dirty,
        PriceBookItemID: x.PriceBookItem.ID,
        ID: x.ID
      }
      optionModel.EstimatePriceBookItems.push(itemModel);
    });
    if (!this.discountSelector.selectedDiscount.IsDeleted) {
      const discount = Object.assign({}, this.discountSelector.selectedDiscount);
      discount.EstimatePriceBookItemIDs = this.itemMetaData.selectedItems.filter(x => x.ID !== undefined).map(x => x.ID);
      optionModel.EstimateOptionDiscountItems.push(discount);
    }
    optionModel.EstimateAttachments = this.attachmentMetaData.attachments;
    if (this.data.EstimateOptions && this.data.EstimateOptions.length > 0) {
      optionModel.ID = this.data.EstimateOptions[0].ID;
      optionModel.Name = this.data.EstimateOptions[0].Name;
      optionModel.Description = this.data.EstimateOptions[0].Description;
    }
    model.EstimateOptions.push(optionModel);
    //#endregion

    //#region Notes
    const internalNoteModel: EstimateNoteModel = {
      Content: estimateInfo.InternalNote? estimateInfo.InternalNote : '',
      TypeID: this.commonMethods.getCodeTypeData('NoteType').find(x => x.Code.toLowerCase() == "estimateinternal").ID
    }
    const externalNoteModel: EstimateNoteModel = {
      Content: estimateInfo.ExternalNote? estimateInfo.ExternalNote : '',
      TypeID: this.commonMethods.getCodeTypeData('NoteType').find(x => x.Code.toLowerCase() == "estimateexternal").ID
    }
    if (this.data.Notes) {
      const externalNote = this.data.Notes.find(x => x.Type.ID === this.commonMethods.getCodeTypeData('NoteType').find(x => x.Code.toLowerCase() == "estimateexternal").ID);
      if (externalNote) {
        externalNoteModel.ID = externalNote.ID;
      }
      const internalNote = this.data.Notes.find(x => x.Type.ID === this.commonMethods.getCodeTypeData('NoteType').find(x => x.Code.toLowerCase() == "estimateinternal").ID);
      if (internalNote) {
        internalNoteModel.ID = internalNote.ID;
      }
    }
    model.Notes.push(internalNoteModel);
    model.Notes.push(externalNoteModel);
    //#endregion
    
    return model;
  }
}
